import api from './api';

export const employeeService = {
  async getEmployees(params = {}) {
    const response = await api.get('/employees', { params });
    return response.data;
  },

  async markAttendance(attendanceData) {
    const response = await api.post('/employees/attendance', attendanceData);
    return response.data;
  },

  async getAttendance(params = {}) {
    const response = await api.get('/employees/attendance', { params });
    return response.data;
  },

  async getEmployeeKPI(employeeId, year, month) {
    const response = await api.get(`/employees/kpi/${employeeId}`, {
      params: { year, month }
    });
    return response.data;
  },

  async getPayroll(params = {}) {
    const response = await api.get('/employees/payroll', { params });
    return response.data;
  }
};